/**
 * Copyright © 2026 Adnuntius AS.
 */
import {firstValueFrom} from 'rxjs';
import {Component, Inject, Input, OnInit, signal} from '@angular/core';
import template from './tier-list-page.component.html';
import * as _ from 'lodash';
import {AngularModalService} from '../../common/modal/angular-modal.service';

import {decorateTiersWithNetworkState} from './tier-commons';
import {TierPriorityModalComponent} from './tier-priority-modal.component';
import {NetworkApiService} from '../network/network-api.service';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {TierApiService} from './tier-api.service';
import {UIRouterModule} from '@uirouter/angular';
import {APP_SHARED} from '../../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule],
  selector: 'adn-tier-list-page',
  template
})
export class TierListPageComponent implements OnInit {
  private readonly tiersState = signal<any[]>([]);
  private readonly resolvedState = signal(false);
  get tiers(): any[] { return this.tiersState(); }
  set tiers(value: any[]) { this.tiersState.set(value); }
  get resolved(): boolean { return this.resolvedState(); }
  set resolved(value: boolean) { this.resolvedState.set(value); }
  @Input() readOnly = false;
  private network: any;

  constructor(
    private readonly tierApi: TierApiService,
    @Inject(NetworkApiService) private Network: NetworkApiService,
    @Inject(LocalNetworkProfile) private LocalNetworkProfile: any,
    private angularModalService: AngularModalService
  ) {
  }

  ngOnInit(): void {
    this.loadTiers();
  }
  updatePriority(): void {
    const modalRef = this.angularModalService.show(TierPriorityModalComponent, {
      class: 'modal-lg',
      initialState: {inputNetwork: this.network}
    });
    (modalRef.content as TierPriorityModalComponent).onSaved.subscribe((updatedNetwork: any) => {
      this.network = updatedNetwork;
      this.loadTiers();
      this.LocalNetworkProfile.set('tiers', updatedNetwork.tiers);
    });
  }

  private loadTiers(): void {
    this.resolved = false;
    const tiersPromise = firstValueFrom(this.tierApi.listAll());
    const networkPromise = this.network || firstValueFrom(this.Network.get(this.LocalNetworkProfile.getNetworkId()));

    Promise.all([tiersPromise, networkPromise]).then((results: any[]) => {
      this.tiers = _.orderBy(decorateTiersWithNetworkState(results[0].results || [], results[1]), 'pos');
      this.network = results[1];
      this.resolved = true;
    });
  }
}
